

















































































import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import { primaryColor } from '@/plugins/vuetify'
import SeletorDeLojas from '@/components/loja/SeletorDeLojas.vue'
import DataTableDeCrudPaginado from '@/components/ui/DataTableDeCrudPaginado.vue'
import { DadosDeVendaProcessada, ItemDoRankingDeProdutos } from '@/models'
import {
	FindDadosDeVendasUsecase,
	FindRankingDeProdutosUseCase,
	ParametrosDoRankingDeProdutos,
	ParametrosFindDadosDeVenda,
} from '@/usecases'
import Axios from 'axios'
import axios, { CancelTokenSource } from 'axios'
import { convertePeriodoParaDatas, Periodo } from '@/shareds/date/date-utils'
import { formatarMoeda } from '@/shareds/formatadores'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { DataOptions } from 'vuetify'
import { ApexOptions } from 'apexcharts'
import { backendDomain, cores } from '@/shareds/utils'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import moment from 'moment'
import { serializarQueryString } from '@/common/request'

@Component({
	components: {
		SeletorDeLojas,
		DataTableDeCrudPaginado,
	},
})
export default class TelaInicialDashBoard extends Vue {
	@Ref() grafico!: ApexOptions
	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}
	totalDeRegistros = 0

	findRankingDeProdutosUseCase = new FindRankingDeProdutosUseCase()
	findDadosDeVendasUseCase = new FindDadosDeVendasUsecase()
	cancelToken: CancelTokenSource | null = null

	chartOptions: ApexOptions = {
		theme: {
			mode: this.$vuetify.theme.dark ? 'dark' : 'light',
		},
		chart: {
			id: 'grafico-faturamento',
			type: 'area',
			stacked: true,
		},
		dataLabels: {
			enabled: false,
		},
		stroke: {
			curve: 'smooth',
		},
		markers: {
			size: 5,
			hover: {
				size: 9,
			},
		},
		fill: {
			type: 'gradient',
			gradient: {
				opacityFrom: 0.3,
				opacityTo: 0.6,
			},
		},
		legend: {
			position: 'top',
			horizontalAlign: 'center',
		},
		yaxis: {
			min: 0,
		},
		xaxis: {
			type: 'datetime',
		},
		tooltip: {
			shared: true,
			intersect: false,
			y: {
				formatter: function (y) {
					if(typeof y !== "undefined") {
						return  `R$ ${y.toFixed(2)}`;
					}
					return y;
				},
			},
		},
		colors: [primaryColor, '#eb3498'],
		title: {
			text: `R$ ${this.totalDeVendas()}`,
			offsetX: 20,
			style: {
				fontSize: '24px',
			},
		},
		subtitle: {
			text: 'Vendas',
			offsetX: 20,
			style: {
				fontSize: '14px',
			},
		},
		grid: {
			show: true,
			position: 'back',
		},
	}

	produtosDoRanking: ItemDoRankingDeProdutos[] = []

	headers = [
		{ text: 'Ranking', value: 'posicaoNoRanking' },
		{ text: 'Produto', value: 'nomeDoProduto' },
		{ text: 'Valor Faturado R$', value: 'valorFaturado' },
		{ text: 'Quantidade', value: 'qtdeFaturada' },
	]

	carregando = false
	dadosDeVenda: DadosDeVendaProcessada[] = []

	get series() {
		const categorias = mapeiaTiposDeClientes(this.dadosDeVenda)

		return categorias
			.map(categoria => {
				const data = this.dadosDeVenda
					.filter(venda => venda.tipoDeCliente?.toUpperCase() === categoria?.toUpperCase())
					.map(venda => [venda.dataHoraVenda.substr(0, 10), venda.totalDaVenda])

				const dadosReduzidos = data.reduce((totais, venda) => {
					const index = totais.findIndex(total => total[0] === venda[0])
					if (index === -1) {
						totais.push(venda as any)
						return totais
					}
					totais[index][1] += venda[1]
					return totais
				}, [])
					.map(serie => [serie[0], serie[1].toFixed(2)])

				const grupo = categoria === null
					? 'Normal'
					: categoria
				return {
					name: grupo,
					data: [...dadosReduzidos],
				}
			})
	}

	get itensDonut() {
		const categorias = mapeiaTiposDeClientes(this.dadosDeVenda)

		return categorias.map((categoria, index) => {
			const total = this.dadosDeVenda
				.reduce((total, atual) => atual.tipoDeCliente?.toUpperCase() === categoria?.toUpperCase() ? total + 1 : total, 0)
			const percentual = (total / this.dadosDeVenda.length) * 100
			return {
				totalCliente: total,
				tipoDeCliente: categoria === null ? 'Normal' : categoria,
				percentual: percentual.toFixed(2),
				cor: cores[index],
			}
		})
	}

	totalDeVendas() {
		if (!this.dadosDeVenda) return 0
		const total = this.dadosDeVenda
			.reduce((total, { totalDaVenda }) => total + totalDaVenda, 0)
		return formatarMoeda(total)
	}

	get tamanhoDoCardDeDonut() {
		return this.itensDonut.length >= 3
			? 4
			: 12/this.itensDonut.length

	}

	@Watch('filtros', { deep: true,  immediate: true })
	async buscaDados(
		parametros: ParametrosDoRankingDeProdutos & ParametrosFindDadosDeVenda,
	) {
		try {
			if (this.cancelToken) this.cancelToken.cancel()
			this.cancelToken = Axios.CancelToken.source()
			this.carregando = true
			const params = {
				...parametros,
				page: {
					page: this.paginacao.page - 1,
					size: this.paginacao.itemsPerPage,
				},
			}
			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}

			this.dadosDeVenda = await this.findDadosDeVendasUseCase.find(params, axiosConfig)
			const pagina = await this.findRankingDeProdutosUseCase.find(params, axiosConfig)
			this.totalDeRegistros = pagina.totalElements
			this.produtosDoRanking = pagina.content

			this.$apexcharts.exec('grafico-faturamento', 'updateOptions', {
				title: {
					text: `R$ ${this.totalDeVendas()}`,
				},
			})
		} catch (e) {
			if (axios.isCancel(e)) return
			AlertModule.setError(e)
		} finally {
			this.carregando = false
		}
	}


	get produtosDoRankingFormatados() {
		return this.produtosDoRanking
			.map(i => ({
				...i,
				valorFaturado: formatarMoeda(i.valorFaturado || 0),
			}))
	}

	get filtros () {
		const [dataInicial, dataFinal ] = convertePeriodoParaDatas(this.periodo || 'Hoje')
		const lojas = this.lojas || undefined
		const pdvs = this.pdvs || undefined
		const filtros = {
			lojas,
			pdvs,
			dataInicial: moment(dataInicial).toISOString(true),
			dataFinal: dataFinal ? moment(dataFinal).endOf('day').toISOString(true) : undefined,
		}
		return filtros
	}

	get urlRelatorioPorVendedor() {
		if (!UserLoginStore.token) return ''
		const queryString = serializarQueryString({
			token: encodeURI(UserLoginStore.token),
			...this.filtros,
		})
		return `${backendDomain()}/vendas/relatorio-por-vendedor/VendasPorVendedor.csv?${queryString}`
	}

	get urlRankigDeProdutos() {
		if (!UserLoginStore.token) return ''
		const queryString = serializarQueryString({
			token: encodeURI(UserLoginStore.token),
			...this.filtros,
		})
		return `${backendDomain()}/vendas/relatorio-ranking-de-produtos/RankingDeProdutos.csv?${queryString}`
	}

	get urlDaRelacaoDeVendas() {
		if (!UserLoginStore.token) return ''
		const queryString = serializarQueryString({
			token: encodeURI(UserLoginStore.token),
			...this.filtros,
		})
		return `${backendDomain()}/vendas/relacao-de-vendas/RelacaoDeVendas.csv?${queryString}`
	}

	get periodo(): Periodo | null {
		const periodoDaQuery = this.$route.query.d
		if (typeof periodoDaQuery === 'string' && moment(periodoDaQuery).isValid()) {
			return [periodoDaQuery, null]
		}
		return (periodoDaQuery as Periodo) || null
	}

	get lojas() {
		if (typeof this.$route.query.l === 'string') return [this.$route.query.l]
		return this.$route.query.l as string[] || null
	}

	get pdvs() {
		return this.$route.query.p as string[] || null
	}
	
}

function mapeiaTiposDeClientes(dados: DadosDeVendaProcessada[]) {
	return dados
		.map(({ tipoDeCliente }) => tipoDeCliente ? tipoDeCliente.toUpperCase() : null)
		.reduce<(string | null)[]>((acc, item) => acc.includes(item)
			? acc
			: [ ...acc, item ]
		, [])
		.sort((a, b) => {
			if (!b) return -1
			if (!a) return 1
			return b.localeCompare(a)
		})
}
